module.exports = __webpack_public_path__ + "static/media/email_color.cb7a862d.svg";